import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import Image from 'gatsby-theme-core/src/components/image';
import Section from '../../components/section';
import VariantButton from '../../components/variant-button';

import ImageWrapper from './image-wrapper';
import HighlightsTitle from './highlights-title';
import Title from './title';

const StyledVariantButton = styled(VariantButton)`
  font-weight: 700;
`;
const Text = styled.p`
  line-height: 150%;
  margin: 0 0 1rem 0;
`;
const Item = styled.article`
  display: flex;
  flex-direction: column;
`;
const Wrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-gap: 2rem;
  grid-template-columns: 1fr;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
    grid-gap: ${(props) => props.theme.grid.columnGap};
    grid-template-columns: repeat(3, 1fr);
  }

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    grid-template-columns: repeat(${({ numberOfItems }) => numberOfItems}, 1fr);
  }
`;

const Highlights = ({
  rowOptions,
  highlights,
  className,
  title,
}) => {
  if (highlights?.length <= 0) {
    return null;
  }

  return (
    <Section
      id={rowOptions?.sectionId || ''}
      backgroundColor={rowOptions?.backgroundColor}
      hideBottomSpacing={rowOptions?.hideBottomSpacing}
      hideTopSpacing={rowOptions?.hideTopSpacing}
      hideRow={rowOptions?.hideRow}
      className={className}
    >
      <Container>
        <HighlightsTitle>{title}</HighlightsTitle>
        <Wrapper numberOfItems={highlights.length}>
          {highlights.map((highlight) => highlight && (
            <Item key={highlight.id}>
              <ImageWrapper to={highlight.button?.link}>
                {highlight.image && (
                  <Image
                    image={highlight.image}
                    alt={highlight.title}
                  />
                )}
              </ImageWrapper>
              {highlight.title && (
                <Title>{highlight.title}</Title>
              )}
              {highlight.text && (
                <Text>{highlight.text}</Text>
              )}
              {highlight.button && (
                <StyledVariantButton
                  variant={highlight.button.variant}
                  to={highlight.button.link}
                >
                  {highlight.button.text}
                </StyledVariantButton>
              )}
            </Item>
          ))}
        </Wrapper>
      </Container>
    </Section>
  );
};

export default styled(Highlights)``;
